<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <router-link
          v-if="
            $store.state.user.is_admin === 1 ||
            $store.state.user.is_admin === 2 ||
            $store.state.user.is_admin === 4
          "
          class="btn btn-primary"
          style="float: right; margin-bottom: 20px"
          to="transport_solicitations/approve"
        >
          Aprovar Solicitações
        </router-link>
      </div>
      <div class="col-md-12">
        <div v-if="loading" class="text-center" style="padding: 50px">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Carregando...</span>
          </div>
          <p class="mt-2">Carregando registros...</p>
        </div>
      </div>

      <base-crud
        v-show="!loading"
        ref="baseCrud"
        crudName="Solicitações de vale-transporte"
        newText="Nova Solicitação"
        :table="transportSolicitationsTable"
        :columns="columns"
        :options="options"
        :endPoint="endPoint"
        :enableAdd="true"
        :enableEdit="false"
        :enableDelete="false"
        :enableView="false"
        :toadd="'transportationRequest'"
        :dataForm="dataForm"
      ></base-crud>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

function format(datetime) {
  return moment(datetime).format("DD/MM/YYYY");
}

export default {
  components: {
    BaseCrud,
  },
  data() {
    return {
      loading: true,

      transportSolicitationsTable: "transportSolicitationsTable",
      columns: [
        "id",
        "date",
        "transport_value",
        "user_id",
        "approver_id",
        "status_id",
      ],
      tableData: [
        "id",
        "date",
        "transport_value",
        "user_id",
        "approver_id",
        "status_id",
      ],
      options: {
        filterByColumn: true,
        filterable: [
          "id",
          "date",
          "transport_value",
          "user_id",
          "approver_id",
          "status_id",
        ],
        sortable: [
          "id",
          "date",
          "transport_value",
          "user_id",
          "approver_id",
          "status_id",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        listColumns: {
          status_id: [
            { id: 1, text: "Pendente" },
            { id: 2, text: "Aceito" },
            { id: 3, text: "Recusado" },
          ],
        },
        texts: {
          filterPlaceholder: "Selecione",
          selectStatusPlaceholder: "Selecione",
        },
        headings: {
          id: "ID",
          date: "Data",
          transport_value: "Valor",
          user_id: "Usuário",
          approver_id: "Aprovador",
          status_id: "Status",
        },
        requestFunction(data) {
          const requestData = {};

          const query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["user", "approver", "status"];

          return axios.get(`${this.url}?${query}`, requestData).catch((e) => {
            this.dispatch("error", e);
          });
        },
        templates: {
          date(h, row, index) {
            return format(row.date);
          },
          user_id(h, row, index) {
            return row.user.name;
          },
          transport_value(h, row, index) {
            const formatter = new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            });
            return formatter.format(row.transport_value);
          },
          approver_id(h, row, index) {
            return row.approver ? row.approver.name : "";
          },
          status_id(h, row, index) {
            return row.status.name;
          },
        },
      },
      endPoint: "transport_solicitations/",

      dataForm: {},
    };
  },

  mounted() {
    const tableRef = this.$refs.baseCrud && this.$refs.baseCrud.$refs.table;
    if (tableRef) {
      tableRef.$once("loaded", () => {
        this.loading = false;

        this.$nextTick(() => {
          const input = this.$el.querySelector('input[name="vf__date"]');
          if (input) {
            input.type = "date";
            input.addEventListener("change", () => {
              input.dispatchEvent(
                new KeyboardEvent("keyup", { bubbles: true }),
              );
            });
          }
        });
      });
    } else {
      this.loading = false;
    }
  },

  methods: {
    query(query) {
      const columns = {
        id: "id",
        date: "date",
        user_id: "name",
        approver_id: "approver_name",
        status_id: "status_id",
        transport_value: "transport_value",
      };
      let filters = "orderByDesc=id&";
      $.each(query, (index, value) => {
        filters += `${columns[index]}=${value}&`;
      });

      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

select[name="vf__status_id"] option:first-child {
  font-size: 0;
}

select[name="vf__status_id"] option:first-child:after {
  content: "Selecione";
  font-size: 14px;
}
</style>
